var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.241 0.815533H11.4167V0.54369C11.4167 0.252428 11.178 0 10.8598 0C10.5614 0 10.3029 0.23301 10.3029 0.54369V0.815533H4.83319V0.54369C4.83319 0.252428 4.59452 0 4.27628 0C3.97794 0 3.71937 0.23301 3.71937 0.54369V0.815533H0.795587C0.338125 0.815533 0 1.12621 0 1.59223V4.66019V15.2427C0 15.6699 0.318235 16 0.795587 16H14.2012C14.6587 16 14.9968 15.6699 14.9968 15.2427V4.66019V1.59223C15.0366 1.16505 14.6985 0.815533 14.241 0.815533ZM1.13371 1.88349H3.75915V2.15534C3.75915 2.4466 3.99782 2.69903 4.31606 2.69903C4.6144 2.69903 4.87297 2.46602 4.87297 2.15534V1.88349H10.3426V2.15534C10.3426 2.4466 10.5813 2.69903 10.8995 2.69903C11.1979 2.69903 11.4565 2.46602 11.4565 2.15534V1.88349H13.9626V4.1165H1.17349V1.88349H1.13371ZM13.9427 14.9126H1.1536V5.18446H13.9427V14.9126ZM3.32157 7.70874H4.97242V9.32038H3.32157V7.70874ZM6.72271 7.70874H8.37356V9.32038H6.72271V7.70874ZM10.1238 7.70874H11.7747V9.32038H10.1238V7.70874ZM3.32157 10.8544H4.97242V12.466H3.32157V10.8544ZM6.72271 10.8544H8.37356V12.466H6.72271V10.8544ZM10.1238 10.8544H11.7747V12.466H10.1238V10.8544Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarLight);
export default __webpack_public_path__ + "static/media/calendar-light.b9ae6fdbb7269b09770da9e221994465.svg";
export { ForwardRef as ReactComponent };